const prospect = 'prospect'
import axios from 'axios'

export default {
  getProspects (context) {
    let params = {query: context.searchQuery, page: context.slectedPage - 1}
    if (params !== {}) {
      params = {params: {query: context.searchQuery, page: context.slectedPage - 1}}
    } else {
      params = { params: {} }
    }
    axios.get(prospect, params).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.setProspects(response.data)
    }, () => {
    })
  },
  addProspect (context, body) {
    axios.post(prospect, body).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.prospectAdded(response.data)
    }, (error) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.prospectNotAdded(error.response.data.return_message)
    })
  },
  updateProspect (context, id, body) {
    axios.put(`${prospect}/${id}`, body).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.prospectUpdated(response.data)
    }, (error) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.prospectNotUpdated(error.response.data.return_message)
    })
  },
  makePayment (context, id, body) {
    axios.put(`${prospect}/${id}/payment`, body).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.paymentCompleted(response.data)
    }, (error) => {
      context.$vs.loading.close()
      context.isLoading = false
      console.log('return_message', error.response.data.return_message)
      context.paymentNotCompleted(error.response.data.return_message)
    })
  },
  orderBackgroundCheck (context, id) {
    axios.put(`background-check/${id}`).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.backgroundCheckCompleted(response.data)
    }, (error) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.backgroundCheckNotCompleted(error.response.data.return_message)
    })
  },
  getProspectById (context, id) {
    axios.get(`${prospect}/${id}`).then((response) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.setProspect(response.data)
    }, (error) => {
      context.$vs.loading.close()
      context.isLoading = false
      context.prospectNotFound(error.response.data.return_message)
    })
  }

}